import { render, staticRenderFns } from "./extend-trial.vue?vue&type=template&id=3596c2e8&"
import script from "./extend-trial.vue?vue&type=script&lang=ts&"
export * from "./extend-trial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports